<template>
    <article>
        <users-actions
            :users="checkedList"
            :meetings="meetings"
            v-if="checkedList.length > 0"
            :list="list"
        ></users-actions>

        <div class="flex flex-col">
            <empty-list :message="empty" v-if="users.length == 0"></empty-list>

            <div
                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                v-if="users.length > 0"
            >
                <div
                    class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
                >
                    <div
                        class="mt-1 mb-4 relative rounded-md shadow-sm group"
                        v-if="searchbox"
                    >
                        <input
                            v-model="search"
                            autocomplete="false"
                            spellcheck="false"
                            id="search"
                            type="search"
                            class="focus:ring-blue-500 focus:border-blue-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md"
                        />
                        <div
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <SearchIcon
                                class="h-5 w-5 text-gray-400 focus:text-blue-500 group-focus:text-blue-500"
                                aria-hidden="true"
                            />
                        </div>
                    </div>

                    <div
                        class="shadow overflow-auto border-b border-gray-200 sm:rounded-lg"
                    >
                        <table
                            class="min-w-full divide-y divide-gray-200 table-auto"
                        >
                            <thead class="bg-blue-800">
                                <tr>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider"
                                    >
                                        <input
                                            type="checkbox"
                                            class="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded hover:opacity-100"
                                            :class="{ 'opacity-60': !checkAll }"
                                            v-model="checkAll"
                                        />
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider w-1/5"
                                    >
                                        {{ t("user.name", "Naam") }}
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider"
                                    >
                                        {{
                                            t(
                                                "user.contactdetails",
                                                "Contactgegevens"
                                            )
                                        }}
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-6 py-3 text-left text-xs font-medium text-gray-50 uppercase tracking-wider hidden md:block"
                                    >
                                        {{ t("user.th_tags", "Tags") }}
                                    </th>
                                    <!-- <th
                                    scope="col"
                                    class="
                                        px-6
                                        py-3
                                        text-left text-xs
                                        font-medium
                                        text-gray-50
                                        uppercase
                                        tracking-wider
                                    "
                                >
                                    Role
                                </th> -->
                                    <th scope="col" class="relative px-6 py-3">
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-gray-50 divide-y divide-gray-200">
                                <user
                                    v-for="(user, personIdx) in filteredList"
                                    r
                                    :class="
                                        personIdx % 2 === 0
                                            ? 'bg-white'
                                            : 'bg-gray-50'
                                    "
                                    :user="user"
                                    :key="user.email"
                                >
                                </user>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </article>
</template>

<script>
import EmptyList from "./EmptyList.vue";
import { SearchIcon } from "@heroicons/vue/solid";

export default {
    components: { EmptyList, SearchIcon },
    mounted() {
        Eventing.listen("openSearchbox", () => this.startSearch());
    },
    created() {
        this.empty = this.t(
            "users.empty-list",
            "In deze lijst zijn (nog) geen deelnemers beschikbaar"
        );
        this.getMeetings();
    },
    props: ["users", "list"],
    data() {
        return {
            checkAll: false,
            search: null,
            empty: null,
            searchbox: false,
            meetings: [],
        };
    },
    methods: {
        startSearch() {
            this.searchbox = true;
            setTimeout(() => {
                document.getElementById("search").focus();
            }, 500);
        },
        getMeetings() {
            axios
                .get("/api/meetings?useractions=true&admin=true")
                .then((response) => {
                    this.meetings = response.data;
                })
                .catch((error) => {});
        },
    },
    computed: {
        filteredList() {
            if (!this.search) return this.users;
            var find = function (object, search) {
                for (var property in object) {
                    if (object.hasOwnProperty(property)) {
                        if (typeof object[property] == "object") {
                            if (find(object[property], search)) return true;
                        } else if (object[property].includes !== undefined) {
                            if (object[property].toLowerCase().includes(search))
                                return true;
                        }
                    }
                }
                return false;
            };
            return this.users.filter((_item) => {
                return find(_item, this.search.toLowerCase());
            });
        },
        checkedList() {
            var self = this;
            try {
                if (this.filteredList) {
                    return this.filteredList.filter(function (u) {
                        return u.checked;
                    });
                }
            } catch (error) {}

            return null;
        },
    },
    watch: {
        checkedList() {
            if (this.checkedList && this.checkedList.length > 0) {
                Eventing.fire("hide-upload");
            } else {
                Eventing.fire("show-upload");
            }
        },
        checkAll(val) {
            if (val == true) {
                this.users.forEach((item) => {
                    item.checked = true;
                });
            } else {
                this.users.forEach((item) => {
                    item.checked = false;
                });
            }
        },
    },
};
</script>
